"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_sortable_hoc_1 = require("react-sortable-hoc");
var generic_1 = require("../generic");
var DragHandle = (0, react_sortable_hoc_1.SortableHandle)(function () {
    return (React.createElement("div", { className: "mr-2 Ordering--handle" },
        React.createElement(generic_1.Icon, { name: generic_1.Icons.grip_vertical })));
});
var OrderingRow = function (props) {
    return (React.createElement("li", { className: "list-group-item d-flex justify-content-between align-items-center Ordering--row Ordering--row__noselect" },
        React.createElement(DragHandle, null),
        React.createElement("div", { className: "form-check flex-grow-1" },
            React.createElement("label", { className: "Ordering--label form-check-label" },
                React.createElement("input", { name: "name", type: "checkbox", className: "form-check-input", checked: props.ordering.active, onChange: props.change }),
                props.ordering.display)),
        React.createElement("div", { className: "form-check flex-grow-1 text-right" },
            React.createElement("label", { className: "Ordering--label form-check-label" },
                React.createElement("input", { name: "ascending", type: "checkbox", className: "form-check-input", checked: props.ordering.ascending, onChange: props.change }),
                "A\u2192Z"))));
};
exports.default = OrderingRow;
